import ogImageAsset from "@/assets/OP2P-CRM-e-Agentes-de-IA-whatsapp-instagram-og.webp.asset.json";

export const SITE_URL = "https://op2p.ai";
import { toOgJpg } from "@/lib/og-jpg";

export const DEFAULT_OG_IMAGE = `${SITE_URL}${toOgJpg(ogImageAsset.url)}`;

export interface HeadMetaInput {
  title: string;
  description: string;
  /** caminho da página, ex: "/precos" */
  path: string;
  type?: "website" | "article";
  image?: string;
  noindex?: boolean;
}

/**
 * Gera meta tags e canonical auto-referenciados por rota (SSR),
 * evitando que qualquer página herde título/canonical da home.
 */
export function buildHead({
  title,
  description,
  path,
  type = "website",
  image = DEFAULT_OG_IMAGE,
  noindex = false,
}: HeadMetaInput) {
  const url = `${SITE_URL}${path.startsWith("/") ? path : `/${path}`}`;
  image = toOgJpg(image.startsWith("http") ? image : `${SITE_URL}${image}`);
  const fullTitle = title.includes("OP2P") ? title : `${title} | OP2P`;

  return {
    meta: [
      { title: fullTitle },
      { name: "description", content: description },
      ...(noindex ? [{ name: "robots", content: "noindex, follow" }] : []),
      { property: "og:title", content: fullTitle },
      { property: "og:description", content: description },
      { property: "og:type", content: type },
      { property: "og:url", content: url },
      { property: "og:image", content: image },
      { property: "og:image:type", content: image.endsWith(".png") ? "image/png" : "image/jpeg" },
      { property: "og:image:secure_url", content: image },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: fullTitle },
      { name: "twitter:description", content: description },
      { name: "twitter:image", content: image },
    ],
    links: [{ rel: "canonical", href: url }],
  };
}
